<template>
  <div class="editor-image-field">
    <span class="ed-label">{{ label }}</span>
    <div class="editor-image-preview" :style="previewStyle">
      <span v-if="!previewPath" class="editor-image-empty"><i class="fal fa-image"></i>Sem imagem</span>
    </div>
    <div class="editor-image-actions">
      <label class="editor-image-pick">
        <input type="file" accept="image/*" @change="onFileChange" />
        <i class="fal fa-upload mr-1"></i>{{ previewPath ? "Trocar" : "Enviar" }}
      </label>
      <button v-if="value" type="button" class="editor-image-undo" @click="$emit('input', null)">Desfazer</button>
    </div>
    <div v-if="maxKb" class="ed-help">Até {{ maxKb }} KB.</div>
  </div>
</template>

<script>
// Seleção de imagem: lê o arquivo como data URI e emite { name, dataUri } (null = manter a atual).
export default {
  name: "EditorImageField",
  props: {
    label: { type: String, required: true },
    currentPath: { type: String, default: null },
    value: { type: Object, default: null },
    maxKb: { type: Number, default: null },
  },
  computed: {
    previewPath() {
      return (this.value && this.value.dataUri) || this.currentPath;
    },
    previewStyle() {
      return this.previewPath ? { backgroundImage: `url(${this.previewPath})` } : {};
    },
  },
  methods: {
    onFileChange(event) {
      const file = event.target.files && event.target.files[0];
      event.target.value = "";
      if (!file) return;

      if (this.maxKb && file.size > this.maxKb * 1024) {
        this.$store.commit("SET_SNACKBAR_MESSAGE", `A imagem deve ter no máximo ${this.maxKb} KB`);
        return;
      }

      const reader = new FileReader();
      reader.onload = () => this.$emit("input", { name: file.name, dataUri: reader.result });
      reader.readAsDataURL(file);
    },
  },
};
</script>

<style scoped>
.editor-image-preview {
  width: 100%;
  max-width: 200px;
  aspect-ratio: 4 / 3;
  border: 1px dashed #c3c6d5;
  border-radius: 8px;
  background-color: #f6f7f9;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.editor-image-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #80849a;
}
.editor-image-empty i {
  font-size: 22px;
}
.editor-image-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px 0 2px;
}
.editor-image-pick,
.editor-image-undo {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: #02acb4;
  background: none;
  border: 0;
  padding: 0;
}
.editor-image-undo {
  color: #80849a;
}
.editor-image-pick input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
</style>
